module.exports = __webpack_public_path__ + "img/T6-A-xs_4.4a1d9480.png";